import { getContext, setContext, hasContext } from 'svelte';

export function createContext<T>(key: string, defaultValue: T) {
  return {
    get: () => {
      if (!hasContext(key) && defaultValue !== undefined) {
        setContext(key, defaultValue);
      }
      return getContext<T>(key);
    },
    set: (value: T) => setContext(key, value),
  };
}
